import { render } from "./CreateItem.vue?vue&type=template&id=9c64ad2c&scoped=true"
import script from "./CreateItem.vue?vue&type=script&lang=js"
export * from "./CreateItem.vue?vue&type=script&lang=js"

import "./CreateItem.vue?vue&type=style&index=0&id=9c64ad2c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c64ad2c"]])

export default __exports__